import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useMutation } from '@apollo/client';
import { GENERATE_SLIDESHOW_IA } from '../../apollo/mutations/generateSlideshow.web.graphql';
import {
  BrandKey,
  GenerateSlideshowIA,
  GenerateSlideshowIAVariables,
} from '../../__generated__/queries-web';
import { GET_USER_OPEN_AI_PROCESSES } from '../../apollo/queries/getOpenAiProcess.web.graphql';

export const SlideshowGenerateForm = ({
  brandKey,
  setActiveTab,
}: {
  brandKey: BrandKey;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [slideshowSubject, setSlideshowSubject] = useState<string | null>(null);
  const [recipeNumber, setRecipeNumber] = useState<number>(0);

  const { pushNotification } = useNotification();
  const [generateDiapoIA] = useMutation<
    GenerateSlideshowIA,
    GenerateSlideshowIAVariables
  >(GENERATE_SLIDESHOW_IA, {
    onCompleted: () => {
      setActiveTab(2);
    },
    refetchQueries: [GET_USER_OPEN_AI_PROCESSES],
  });
  return (
    <form
      onSubmit={(formEvent) => {
        formEvent.preventDefault();
        if (!slideshowSubject || !recipeNumber) {
          return pushNotification({
            type: NotificationTypeEnum.error,
            message: 'Le sujet et la longueur du diaporama sont obligatoires.',
          });
        }
        try {
          generateDiapoIA({
            variables: {
              ...{
                recipeNumber,
                slideshowSubject,
                brandKey,
              },
            },
          });
        } catch (e) {
          pushNotification({
            type: NotificationTypeEnum.error,
            message: 'Erreur lors de la génération du diaporama',
          });
        }
      }}
    >
      <Card
        variant="outlined"
        sx={{
          padding: '40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
          }}
        >
          <AutoFixHighIcon
            fontSize="small"
            sx={{ marginRight: '2px', color: 'text.secondary' }}
          />
          <Typography
            sx={{ fontSize: 14, paddingTop: '1.5px' }}
            color="text.secondary"
            gutterBottom
          >
            Paramètres du diaporama
          </Typography>
        </Box>
        <Box>
          <FormControl sx={{ minWidth: '45%' }}>
            <InputLabel id="diapoType">Type de diaporama</InputLabel>
            <Select
              key={'1'}
              label="Type de diaporama"
              labelId="diapoType"
              value={'recipe'}
              onChange={() => {}}
            >
              <MenuItem key={'1'} value={'recipe'}>
                Recette
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: 'flex',
            // flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '16px',
          }}
        >
          <TextField
            sx={{
              width: '45%',
            }}
            id="outlined-error"
            type="number"
            label="Nombre de recettes"
            value={recipeNumber}
            onChange={(e) => setRecipeNumber(parseInt(e.target.value, 10))}
            required
          />
          <TextField
            sx={{
              width: '45%',
            }}
            id="outlined-error-helper-text"
            label="Sujet du diaporama"
            placeholder=""
            required
            value={slideshowSubject}
            onChange={(e) => setSlideshowSubject(e.target.value)}
          />
        </Box>
        <DialogActions>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              data-testid="confirmBtn"
              color="primary"
              onClick={() => null}
              variant="contained"
              type="submit"
            >
              {'Générer le diaporama'}
            </Button>
          </Box>
        </DialogActions>
      </Card>
    </form>
  );
};
